import React, { useEffect, useState } from "react";
import { Client } from "@twilio/conversations";
import ConversationTitleModal from "../modals/ConversationTitleModal";
import { addConversation } from "../../api/api";
import { Button } from "@twilio-paste/button";
import { PlusIcon } from "@twilio-paste/icons/esm/PlusIcon";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators, AppState } from "../../store";
import { getTranslation } from "../../utils/localUtils";
import { Box } from "@twilio-paste/box";
import { LoadingIcon } from "@twilio-paste/icons/esm/LoadingIcon";
import {
  successNotification,
  unexpectedErrorNotification,
} from "../../helpers";
import styles from "./NewCreateConversations.module.css";

interface NewConvoProps {
  client?: Client;
  collapsed: boolean;
}

const NewCreateConversationButton: React.FC<NewConvoProps> = (props) => {
  const dispatch = useDispatch();
  const {
    updateCurrentConversation,
    addNotifications,
    updateParticipants,
    getConversations,
  } = bindActionCreators(actionCreators, dispatch);

  const local = useSelector((state: AppState) => state.local);
  const createNewConvo = getTranslation(local, "createNewConvo");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpen = () => setIsModalOpen(true);

  const [isReloadDisabled, setIsReloadDisabled] = useState(false);
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    let t: number | undefined;
    if (isReloadDisabled) {
      t = window.setTimeout(() => setIsReloadDisabled(false), 10_000);
    }
    return () => {
      if (t) window.clearTimeout(t);
    };
  }, [isReloadDisabled]);

  const handleReload = async () => {
    if (isReloadDisabled || isReloading) return;

    setIsReloadDisabled(true);
    setIsReloading(true);

    try {
      await getConversations();
      successNotification({
        message: "Aggiornamento effettuato con successo.",
        addNotifications,
      });
    } catch (e: any) {
      unexpectedErrorNotification(
        e?.message ?? "Errore durante l'aggiornamento conversazioni.",
        addNotifications
      );
    } finally {
      setIsReloading(false);
    }
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="end"
        alignItems="center"
        alignContent="center"
        columnGap="space30"
      >
        <Button fullWidth variant="secondary" onClick={handleOpen}>
          <PlusIcon decorative={false} title="Add convo" />
          {!props.collapsed ? createNewConvo : null}
        </Button>

        {!props.collapsed ? (
          <Button
            variant="secondary"
            onClick={handleReload}
            disabled={isReloadDisabled}
          >
            <Box
              as="span"
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              className={isReloading ? styles.spin : undefined}
            >
              <LoadingIcon decorative={false} title="Reload" />
            </Box>
          </Button>
        ) : null}
      </Box>

      <ConversationTitleModal
        title=""
        type="new"
        isModalOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSave={async (title: string) => {
          const convo = await addConversation(
            title,
            updateParticipants,
            props.client,
            addNotifications
          );
          setIsModalOpen(false);
          updateCurrentConversation(convo.sid);
        }}
      />
    </>
  );
};

export default NewCreateConversationButton;
